export const START_CAREER_PATH_GAME_COMPLETED = "careerPath/startGameCompleted";
export const GUESS_DRIVER_COMPLETED = "careerPath/guessDriverCompleted";
export const GET_GAME_STATUS_COMPLETED = "careerPath/getGameStatusCompleted";
export const GET_DRIVER_SUGGESTIONS_COMPLETED = "careerPath/getDriverSuggestionsCompleted";
export const CLEAR_DRIVER_SUGGESTIONS = "careerPath/clearDriverSuggestions";
